import React from 'react';
import { Button, Space, Row, Col, Spin, Pagination } from 'antd';
import DataTable from '../common/table';
import memoDataColumns from './MemoTableColumns';

const MemoTable = ({ data, loading, totalElements, page, pageSize, onPageChange }) => {
    return (
        <div className="table-section" style={{ overflow: 'auto', width: '100%' }}>
            <Spin spinning={loading}>
                <DataTable
                    cols={memoDataColumns}
                    data={data}
                    perPage={pageSize}
                    totalElements={totalElements}
                    onPageChange={onPageChange}
                />
            </Spin>
        </div>
    );
};

export default MemoTable;
